<template>
    <div class="com-partm11">
        <MyTitle title="负载趋势" />
        <MyTitle class="mt-20" type="2" title="GPU用量趋势" />
        <div class="p-content flex align-center">
            <myEchart
                v-if="showGPU"
                :id="'showGPU'"
                :options="GPUOptions" />
        </div>
        <MyTitle class="mt-20" type="2" title="CPU用量趋势" />
        <div class="p-content flex align-center">
            <myEchart
                v-if="showCPU"
                :id="'showCPU'"
                :options="CPUOptions" />
        </div>
        <MyTitle class="mt-20" type="2" title="内存用量趋势" />
        <div class="p-content flex align-center">
            <myEchart
                v-if="showRAM"
                :id="'showRAM'"
                :options="RAMOptions" />
        </div>
        <MyTitle class="mt-20" type="2" title="存储用量趋势" />
        <div class="p-content flex align-center">
            <myEchart
                v-if="showmemory"
                :id="'showmemory'"
                :options="memoryOptions" />
        </div>
    </div>
</template>

<script>
import MyTitle from './myTitle1.vue'
import myEchart from "./charts/echarts"
import * as echarts from 'echarts5'
import { dataInterface } from "@/api/dataInterfaceApi"
export default {
    components: {
        MyTitle,
        myEchart
    },
    data() {
        return {
			// GPU用量趋势
			showGPU: false,
			GPUOptions: {}, 
			// CPU用量趋势
			showCPU: false,
			CPUOptions: {}, 
			// 内存用量趋势
			showRAM: false,
			RAMOptions: {}, 
			// 存储用量趋势
			showmemory: false,
			memoryOptions: {},
			timer: null
        }
    },
	mounted() {

		// GPU用量趋势
		this.getGPUdata()

		// CPU用量趋势
		this.getCPUdata()

		// 内存用量趋势
		this.getRAMdata()

		// 存储用量趋势
		this.getmemorydata()
		// 定时器
		if(this.timer) {
			clearInterval(this.timer)
		}
        this.timer = setInterval(() =>{
			// GPU用量趋势
			this.getGPUdata()

			// CPU用量趋势
			this.getCPUdata()

			// 内存用量趋势
			this.getRAMdata()

			// 存储用量趋势
			this.getmemorydata()
        }, 60 * 1000 * 15)
    },
	methods: {
		// GPU用量趋势
		getGPUdata() {
			let params = { 
				enCode: 'computingpower-right-gpuylqs',
			}
			this.showGPU = false
			dataInterface.dataFaceApi(params).then(res => {
				console.log(res, 'GPU用量趋势')
				if(!res || !res.length) return
				let xAxisData = []
				let seriesData = []
				res.map(item => {
					xAxisData.push(item.cur_hours)
					seriesData.push(item.gpuUsageRate)
				})
				this.GPUOptions = {
					tooltip: {
						trigger: 'none',
						axisPointer: {
							type: 'cross'
						}
					},
					legend: {},
					xAxis: [
						{
							type: 'category',
							axisTick: {
								alignWithLabel: true
							},
							axisLine: {
								onZero: false,
								lineStyle: {}
							},
							data: xAxisData
						}
					],
					yAxis: [
						{
							type: 'value',
							name: '%'
						}
					],
					series: [
						{
							name: '',
							type: 'line',
							smooth: true,
							emphasis: {
								focus: 'series'
							},
							lineStyle: {
								width: 2,
								color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
										offset: 0,
										color: '#6BFCFF'
									},
									{
										offset: 1,
										color: '#6BFCFF'
									}])
							},
							areaStyle: {
								opacity: 0.8,
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: 'rgba(139, 207, 208, 1)'
								},
								{
									offset: 1,
                                    color: 'rgba(134, 201, 203, 0)'
								}])
							},
							data: seriesData,
							tooltip: {
                                valueFormatter: function (value) {
                                    return value;
                                }
							}
						},
					]
				}
				this.showGPU = true
			})
		},
		// CPU用量趋势
		getCPUdata() {
			let params = { 
				enCode: 'computingpower-right-cpuylqs',
			}
			this.showCPU = false
			dataInterface.dataFaceApi(params).then(res => {
				console.log(res, 'CPU用量趋势')
				if(!res || !res.length) return
				let xAxisData = []
				let seriesData = []
				res.map(item => {
					xAxisData.push(item.cur_hours)
					seriesData.push(item.cpuUsageRate)
				})
				this.CPUOptions = {
					tooltip: {
						trigger: 'none',
						axisPointer: {
							type: 'cross'
						}
					},
					legend: {},
					xAxis: [
						{
							type: 'category',
							axisTick: {
								alignWithLabel: true
							},
							axisLine: {
								onZero: false,
								lineStyle: {}
							},
							data: xAxisData
						}
					],
					yAxis: [
						{
							type: 'value',
							name: '%'
						}
					],
					series: [
						{
							name: '',
							type: 'line',
							smooth: true,
							emphasis: {
								focus: 'series'
							},
							lineStyle: {
								width: 2,
								color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
										offset: 0,
										color: '#45A2E5'
									},
									{
										offset: 1,
										color: '#45A2E5'
									}])
							},
							areaStyle: {
								opacity: 0.8,
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: 'rgba(69, 162, 229, 1)'
								},
								{
									offset: 1,
                                    color: 'rgba(99, 163, 209, 0)'
								}])
							},
							data: seriesData,
							tooltip: {
                                valueFormatter: function (value) {
                                    return value;
                                }
							}
						},
					]
				}
				this.showCPU = true
			})
		},
		// 内存用量趋势
		getRAMdata() {

			let params = { 
				enCode: 'computingpower-right-ncylqs',
			}
			this.showRAM = false
			dataInterface.dataFaceApi(params).then(res => {
				console.log(res, '内存用量趋势')
				if(!res || !res.length) return
				let xAxisData = []
				let seriesData = []
				res.map(item => {
					xAxisData.push(item.cur_hours)
					seriesData.push(item.memoryUsageRate)
				})
				this.RAMOptions = {
					tooltip: {
						trigger: 'none',
						axisPointer: {
							type: 'cross'
						}
					},
					legend: {},
					xAxis: [
						{
							type: 'category',
							axisTick: {
								alignWithLabel: true
							},
							axisLine: {
								onZero: false,
								lineStyle: {}
							},
							data: xAxisData
						}
					],
					yAxis: [
						{
							type: 'value',
							name: '%'
						}
					],
					series: [
						{
							name: '',
							type: 'line',
							smooth: true,
							emphasis: {
								focus: 'series'
							},
							lineStyle: {
								width: 2,
								color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
										offset: 0,
										color: '#F9B841'
									},
									{
										offset: 1,
										color: '#F9B841'
									}])
							},
							areaStyle: {
								opacity: 0.8,
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: 'rgba(223, 173, 81, 1)'
								},
								{
									offset: 1,
                                    color: 'rgba(201, 171, 116, 0)'
								}])
							},
							data: seriesData,
							tooltip: {
                                valueFormatter: function (value) {
                                    return value;
                                }
							}
						},
					]
				}
				this.showRAM = true
			})
		},
		// 存储用量趋势
		getmemorydata() {
			let params = { 
				enCode: 'computingpower-right-ccylqs',
			}
			this.showmemory = false
			dataInterface.dataFaceApi(params).then(res => {
				console.log(res, '存储用量趋势')
				if(!res || !res.length) return
				let xAxisData = []
				let seriesData = []
				res.map(item => {
					xAxisData.push(item.cur_hours)
					seriesData.push(item.diskUsageRate)
				})
				this.memoryOptions = {
					tooltip: {
						trigger: 'none',
						axisPointer: {
							type: 'cross'
						}
					},
					legend: {},
					xAxis: [
						{
							type: 'category',
							axisTick: {
								alignWithLabel: true
							},
							axisLine: {
								onZero: false,
								lineStyle: {}
							},
							data: xAxisData
						}
					],
					yAxis: [
						{
							type: 'value',
							name: '%'
						}
					],
					series: [
						{
							name: '',
							type: 'line',
							smooth: true,
							emphasis: {
								focus: 'series'
							},
							lineStyle: {
								width: 2,
								color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
										offset: 0,
										color: '#6BFCFF'
									},
									{
										offset: 1,
										color: '#6BFCFF'
									}])
							},
							areaStyle: {
								opacity: 0.8,
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: 'rgba(139, 207, 208, 1)'
								},
								{
									offset: 1,
                                    color: 'rgba(134, 201, 203, 0)'
								}])
							},
							data: seriesData,
							tooltip: {
                                valueFormatter: function (value) {
                                    return value;
                                }
							}
						},
					]
				}
				this.showmemory = true
			})
		},
    },
	destroyed() {
		clearInterval(this.timer)
	}
}
</script>

<style lang="scss" scoped>
@import './comm.scss';
.com-partm11 {
    width: 100%;
    // height: 720px;
    .pue-list {
        height: 162px;
        .pue-item {
            height: 100%;
            background: url(~@/assets/images/computility/dispatch-icon5.png) center no-repeat;
            background-size: 165px 162px;
            > p {
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: $FontSize24;
            }
            .label {
                height: 38px;
            }
            .value {
                font-family: 'DS-Digital-Bold';
                font-size: $FontSize30;
            }
        }
    }
    .p-content {
        width: 100%;
        height: 280px;
    }
}
</style>